import ThankYouPage from './ThankYou';

export default ThankYouPage;
